/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import _ from "underscore";
import baustein from "baustein";
import analytics from "../analytics/analytics";
import environment from "../modules/environment";
import userProfiler from "../modules/userprofiler";
import facebookEvents from "../analytics/facebook-events";
import doubleclickEvents from "../analytics/doubleclick-events";
import EmailCaptureOverlay from "./overlays/email-capture-overlay";
import template from "templates/modules/email_capture_prompt";
import formutils from "../dom/forms";
import browser from "../utils/browser";

export const selectors = {
    EMAIL_CAPTURE_FORM: ".email-capture-prompt__cta-form"
};

/**
 * @summary this component is in serious need of refactor
 *     @todo make it markup agnostic (so we can use it in any type of HTML element)
 *     @todo prevent the template from spitting any markup (so it can be markup agnostic)
 *     @todo just needs to read clicks no need at all to use a form
 *     @todo abstract `methodMap` so that others component can read it
 *
 * @description Since most types of email capture will be very similar we are using an adapter
 * pattern here instead of having to use if statements in every component method.
 */
export default baustein.register("email-capture-prompt", {
    template,

    setupEvents(add) {
        add("submit", selectors.EMAIL_CAPTURE_FORM, this.onSubmit);
        add("click", ".email-capture-prompt__text-button", this.onSubmit);
        add("emailCaptureSuccess", "email-capture-overlay", this.onEmailCaptureSuccess);
        add("closeOverlay", "email-capture-overlay", this.onOverlayClose);
    },

    defaultOptions: {
        alertForId: null,
        captureType: "",
        captureStyle: "",
        glyph: null,
        isNewEmailCapture: false,
        renderToText: "",
        returnUrl: "",
        successGlyph: null,
        successMode: "",
        text: "",
        toUrl: ""
    },

    methodMap: {
        designer_update: {
            checkSuccess(alertForId) {
                return userProfiler.hasDesignerUpdateSet(alertForId);
            },
            captureSuccess(alertForId) {
                userProfiler.saveDesignerUpdate(alertForId);
            }
        },
        designer_update_lyst: {
            checkSuccess(alertForId) {
                return userProfiler.hasDesignerUpdateSet(alertForId);
            },
            captureSuccess(alertForId) {
                userProfiler.saveDesignerUpdate(alertForId);
            }
        },
        stock_alert: {
            checkSuccess(alertForId) {
                return userProfiler.hasStockAlertSet(alertForId);
            },
            captureSuccess(alertForId) {
                userProfiler.saveStockAlert(alertForId);
            }
        }
    },

    _render() {
        let success = false;
        const method = "checkSuccess";

        if (_.contains(Object.keys(this.methodMap), this.options.captureType)) {
            success = this.methodMap[this.options.captureType][method](this.options.alertForId);
        }

        let form = this.el.querySelector(selectors.EMAIL_CAPTURE_FORM);

        this.setRenderContext({
            csrf_token: form.elements["csrfmiddlewaretoken"].value,
            email_capture_prompt: {
                alert_for_id: this.options.alertForId,
                capture_style: this.options.captureStyle,
                capture_type: this.options.captureType,
                glyph: this.options.glyph,
                is_new_email_capture: this.options.isNewEmailCapture,
                is_success: success,
                render_to_text: this.options.renderToText,
                return_url: this.options.returnUrl,
                success_mode: this.options.successMode,
                success_glyph: this.options.successGlyph,
                text: this.options.text,
                cta_type: this.options.ctaType,
                to_url: this.options.toUrl,
                submit_method: form.method
            }
        });
    },

    trackSuccess() {
        const method = "captureSuccess";

        if (_.contains(Object.keys(this.methodMap), this.options.captureType)) {
            this.methodMap[this.options.captureType][method](this.options.alertForId);
        }
    },

    isMobile() {
        return browser.getViewport() === browser.VIEWPORTS.MOBILE;
    },

    onInsert() {
        this._render();
    },

    onSubmit(event) {
        event.preventDefault();
        const form = this.el.querySelector(selectors.EMAIL_CAPTURE_FORM);

        if (userProfiler.isLoggedIn()) {
            analytics.event("email_capture", "auth_create", this.options.captureType);
            return;
        }

        analytics.event("email_capture", "intent", this.options.captureType);

        if (this.isMobile()) {
            if (event.type !== "submit") {
                form.submit();
            }
            return;
        }

        let renderSucessView = true;
        let overlaySize = "medium";

        if (this.options.isNewEmailCapture) {
            renderSucessView = false;
            overlaySize = "small";
        }

        const options = {
            path: form.action,
            overlaySize: overlaySize,
            queryParams: formutils.serialize(form),
            renderSuccessView: renderSucessView
        };

        const emailCaptureOverlay = new EmailCaptureOverlay(options);
        emailCaptureOverlay.appendTo(this).open();
        this.emit("openOverlay");
    },

    onEmailCaptureSuccess(event) {
        this.trackSuccess();
        analytics.event("email_capture", "created", this.options.captureType);
        analytics.tagEvent(analytics.TAG_NETWORKS.FACEBOOK, facebookEvents.EMAIL_SIGNUP);
        analytics.tagEvent(analytics.TAG_NETWORKS.DOUBLECLICK, doubleclickEvents.ANON_SIGN_UP, {
            atc_country: environment.get("country")
        });
        event.stopPropagation();
    },

    onOverlayClose() {
        this._render();
    }
});

